export default {
  setOverrideFields (state, { data, mediation }) {
    state.overrideFields[mediation] = data
  }
}
